import { WebsiteEnv } from '@/constants/website-env';
import clsx from 'clsx';
import { useState } from 'react';
import ReactPlayer from 'react-player';
import { Dialog, DialogContent } from '../ui/dialog';

interface Props {
  videoUrl: string;
  hasSpecialImage: boolean;
  onScrollToSpecialImage: () => void;
}

const MobileVideoPreview = (props: Props) => {
  const { videoUrl, hasSpecialImage, onScrollToSpecialImage } = props;

  const [videoDialogVisible, setVideoDialogVisible] = useState(false);

  const handleMobileVideoPreview = () => {
    setVideoDialogVisible(true);
  };

  return (
    <>
      <div
        className={clsx(
          'flex h-[50px] items-center bg-[#ABA6A0] ',
          hasSpecialImage && videoUrl ? '' : 'justify-center',
        )}
      >
        {videoUrl ? (
          <button
            type='button'
            className='flex h-full flex-1 items-center justify-center gap-x-2  outline-0'
            onClick={handleMobileVideoPreview}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='33'
              height='34'
              fill='none'
              viewBox='0 0 33 34'
            >
              <path
                stroke='#fff'
                strokeWidth='2'
                d='M16.5 31C24.508 31 31 24.508 31 16.5S24.508 2 16.5 2 2 8.492 2 16.5 8.492 31 16.5 31Z'
              />
              <path
                fill='#fff'
                stroke='#fff'
                d='M21.55 15.653c.6.376.6 1.318 0 1.694l-7.2 4.52c-.6.377-1.35-.094-1.35-.847v-9.04c0-.753.75-1.224 1.35-.847z'
              />
            </svg>
            <span className='text-sm text-white'>Video</span>
          </button>
        ) : null}
        {hasSpecialImage && videoUrl ? <div className='h-full w-px bg-white/30' /> : null}
        {hasSpecialImage ? (
          <button
            type='button'
            className='flex h-full flex-1 items-center justify-center gap-x-2  outline-0'
            onClick={() => {
              onScrollToSpecialImage?.();
            }}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='35'
              height='20'
              fill='none'
              viewBox='0 0 35 20'
            >
              <g
                fill='#fff'
                clipPath='url(#clip0_11759_149342)'
              >
                <path d='M17.499.148C24.9.148 31.386 3.928 35 9.598c-3.614 5.668-10.1 9.448-17.501 9.448S3.61 15.266-.002 9.597c3.616-5.669 10.1-9.449 17.5-9.449m0 16.643c4.068 0 7.367-3.185 7.367-7.112s-3.3-7.112-7.367-7.112-7.368 3.185-7.368 7.112 3.3 7.112 7.368 7.112' />
                <path d='M12.948 7.44a2.22 2.22 0 0 0 1.894 1.036c1.222 0 2.215-.957 2.215-2.139a2.1 2.1 0 0 0-.623-1.485c.343-.07.7-.11 1.065-.11 2.824 0 5.114 2.21 5.114 4.937 0 2.726-2.29 4.936-5.114 4.936s-5.113-2.21-5.113-4.936a4.8 4.8 0 0 1 .562-2.239' />
              </g>
              <defs>
                <clipPath id='clip0_11759_149342'>
                  <path
                    fill='#fff'
                    d='M35 .148H0v18.9h35z'
                  />
                </clipPath>
              </defs>
            </svg>
            <span className='text-sm text-white'>{WebsiteEnv.isUnitedKingdom ? 'Colour' : 'Color'} Comparison</span>
          </button>
        ) : null}
      </div>
      <Dialog open={videoDialogVisible}>
        <DialogContent
          className=' z-[200] h-full w-full'
          showCloseButton={false}
        >
          <div className='relative h-full w-full'>
            <button
              type='button'
              className={clsx(
                ' absolute -right-6 -top-6 h-6 w-6 ',
                'after_h-0.5 after_w-5 after_bg-theme after_content-[""] ',
                'after_absolute after_left-1/2 after_top-1/2 after_-translate-x-1/2 after_-translate-y-1/2',
                'before_h-0.5 before_w-5 before_bg-theme before_content-[""] ',
                'before_absolute before_left-1/2 before_top-1/2 before_-translate-x-1/2 before_-translate-y-1/2',
                'before_-rotate-45 after_rotate-45',
              )}
              onClick={() => {
                setVideoDialogVisible(false);
              }}
            />
            <ReactPlayer
              url={videoUrl}
              loop={false}
              controls
              muted={false}
              playbackRate={1}
              width={'100%'}
              height={'100%'}
            />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default MobileVideoPreview;
